
export default {
  placeInput: {
    findAPlace: 'Buscar por local',
    place: 'Local',
    addRouteStop: 'Adicionar uma parada',
    routePlace: 'Parada',
    routeDestination: 'Destino',
    placeNameRequired: 'Nome do local requerido',
    yourLocation: 'Sua localização',
    couldNotDetermineYourLocation: 'Não foi possível determinar sua localização. Assegure-se de conceder as permissões necessárias',
    useYourLocation: 'Use sua localização atual',
    removeInput: 'Remover local/campo',
    directions: 'Direções',
    fromYourBrowser: 'do seu dispositivo',
    addStartingPlace: 'Adicionar um ponto de partida',
    startingPlace: 'Ponto de partida',
    openInputOptions: 'Mostrar opções do campo',
    addInput: 'Adicionar um campo de local',
    switchCoords: 'Inverter coordenadas',
    rawCoordinate: 'Coordenadas simples lat,lng',
    fillOrRemoveInput: 'Busque ou selecione no mapa usando o botão de mapa ao lado',
    noPlaceFound: 'Nenhum resultado retornado',
    unknownSearchPlaceError: 'Erro desconhecido na busca por local',
    approximateDistance: 'Distância aproximada em linha reta do centro atual do mapa',
    couldNotDetermineYourPreciseLocationUsingPreviousLocation: 'Não foi possível determinar sua localização precisa. Sua localização anterior será utilizada',
    pleaseTypeSomething: 'Digite algo para buscar',
    toggleDirect: 'Alternar para modo direto daqui até o próximo local',
    clickOnTheMapToSelectAPlace: 'Selecione um local clicando num ponto do mapa',
    clickOnTheMapBtnToPickAPlace: 'Clique neste botão para selecionar um local no map para este campo',
    goToDirectionsMode: 'Clique no botão de rota para ativar o modo rotas',
    clickToSearchAndShowResultsOnTheMap: 'Click para buscar e exibir os resultados no mapa'
  }
}
